var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 40,
    viewBox: "0 0 60 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3144_23287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6429 38.9148C19.8531 39.5119 17.5746 40 15.6762 40C8.3532 40 5.5329 37.1789 5.5329 30.0183V20.2883H0V19.5857L14.6997 0V11.7173H21.6429V20.2883H14.6997V28.1741C14.6997 30.778 15.8931 31.8088 17.7915 31.8088C19.1475 31.8088 20.3409 31.4833 21.6429 30.6696V38.9148Z",
    fill: "url(#paint0_radial_3144_23287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5512 12.5287L45.2425 23.1615C43.2898 21.4256 41.3911 20.6116 38.9506 20.6116C36.1297 20.6116 34.3939 22.5104 34.3939 26.0366V39.4553H24.793V11.7154H34.3402V25.4398C34.6111 20.8831 35.3164 17.4113 36.5638 14.9703C37.8118 12.529 40.09 11.2812 43.3447 11.2812C45.2971 11.2812 47.1952 11.8237 48.5512 12.5287Z",
    fill: "url(#paint1_radial_3144_23287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7988 33.3953C55.6125 33.3236 55.3878 33.2812 55.1208 33.2812C54.5886 33.2837 54.2313 33.4505 53.9883 33.7058C53.7465 33.9623 53.61 34.331 53.6094 34.7811C53.6094 35.1309 53.6844 35.4252 53.8191 35.6517C53.955 35.8782 54.1461 36.0459 54.4269 36.1545C54.6144 36.2263 54.8439 36.2689 55.1208 36.2689C55.3998 36.2689 55.6299 36.2251 55.8174 36.1522C56.0052 36.0789 56.1516 35.9775 56.2692 35.8518C56.5026 35.6019 56.631 35.2368 56.6316 34.7811C56.6316 34.4294 56.553 34.1333 56.4141 33.9041C56.2746 33.6743 56.0778 33.5042 55.7988 33.3953Z",
    fill: "url(#paint2_radial_3144_23287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2383 0V39.4576H60.0024V0H50.2383ZM52.3593 24.2501C53.0235 23.5613 53.9949 23.1334 55.167 23.1352C56.1399 23.1343 56.9556 23.4049 57.5739 23.879C58.1847 24.3458 58.5939 25.0035 58.7991 25.7472L56.4585 26.22C56.3778 25.9698 56.2536 25.776 56.0787 25.6374C55.8744 25.4775 55.5882 25.3734 55.1673 25.3722C54.9162 25.3722 54.7035 25.4106 54.5247 25.4811C54.3456 25.5519 54.1983 25.6533 54.0693 25.7952C53.8116 26.0853 53.682 26.4175 53.6793 26.8717C53.6802 27.3337 53.8191 27.6982 54.0573 27.9488C54.2967 28.1984 54.6465 28.3574 55.1556 28.3595C55.5687 28.3586 55.8558 28.2542 56.0649 28.0943C56.1819 28.0037 56.2764 27.8894 56.3532 27.7558L58.728 28.2356C58.509 28.8815 58.1241 29.4585 57.5613 29.8779C56.9499 30.3348 56.1396 30.5976 55.1559 30.5967C53.9547 30.5988 52.9824 30.1854 52.3266 29.4999C51.6699 28.8155 51.3369 27.8783 51.3375 26.8714C51.3369 25.8756 51.6939 24.938 52.3593 24.2501ZM57.9891 37.4015C57.3318 38.0907 56.3499 38.5095 55.1205 38.5074C53.9031 38.5095 52.9224 38.0973 52.2615 37.4114C51.5997 36.7271 51.2664 35.7889 51.2673 34.782C51.2667 33.7887 51.6105 32.8502 52.2741 32.1605C52.9368 31.4695 53.9163 31.0432 55.1205 31.045C56.322 31.0432 57.3012 31.4557 57.9657 32.1419C58.6314 32.8265 58.9746 33.7674 58.9737 34.7817C58.9743 35.7766 58.6476 36.7136 57.9891 37.4015Z",
    fill: "url(#paint3_radial_3144_23287)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3144_23287",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.5509 38.5672) scale(72.9207 72.9258)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F36C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0185,
    stopColor: "#E96E2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0493,
    stopColor: "#D67536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    stopColor: "#B67C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1347,
    stopColor: "#868463"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1863,
    stopColor: "#288B7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1912,
    stopColor: "#088B82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2813,
    stopColor: "#088AB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#3189AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3424,
    stopColor: "#5D879F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3911,
    stopColor: "#898384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4484,
    stopColor: "#B97C60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5123,
    stopColor: "#EF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5151,
    stopColor: "#F36C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7699,
    stopColor: "#EF3F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#088B82"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3144_23287",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.3365 12.7827) scale(54.3243 54.3281)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005618,
    stopColor: "#088B82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4196,
    stopColor: "#F36C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5272,
    stopColor: "#F15B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6514,
    stopColor: "#F04C32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7949,
    stopColor: "#EF4235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF3F36"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3144_23287",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.3022 47.5136) scale(66.0996 66.1043)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088AB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0556,
    stopColor: "#3189AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1482,
    stopColor: "#5D879F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2663,
    stopColor: "#898384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4053,
    stopColor: "#B97C60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5604,
    stopColor: "#EF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5674,
    stopColor: "#F36C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8652,
    stopColor: "#EF3F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#088B82"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3144_23287",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.3019 47.5149) scale(66.0996 66.1043)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088AB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0556,
    stopColor: "#3189AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1482,
    stopColor: "#5D879F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2663,
    stopColor: "#898384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4053,
    stopColor: "#B97C60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5604,
    stopColor: "#EF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5674,
    stopColor: "#F36C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8652,
    stopColor: "#EF3F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#088B82"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3144_23287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.065404ecb1a6efffca9e27e2919d33e5.svg";
export { ForwardRef as ReactComponent };